import React, { useRef, useState } from 'react';
import { MadadAgencyCard } from '../entities';
import AgencySmartCard from 'components/madad/agency-card/AgencySmartCard';
import { CarouselItem } from './styled';
import { LocalWinnersCarousel } from './LocalWinnersCarousel';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';
import { TopTenBadgeVariant } from 'components/madad/top-ten-badge';
import { variantToImagePath } from 'screens/MadadPage/card/consts';

interface AgenciesCarouselProps {
  agencies: MadadAgencyCard[];
  onCardClickEvent?: (id: string) => void;
  variantToImagePath?: Record<TopTenBadgeVariant, string>;
}

export const AgenciesCarousel: React.FC<AgenciesCarouselProps> = props => {
  const { agencies } = props;
  const isMobile = useScreenBreakpoint() === 1;
  const [ sectionInView, setSectionInView ] = useState(false);
  const carouselSectionNode = useRef<HTMLDivElement>(null);

  useIntersectionObserver(([ entry ]) => {
    setSectionInView(entry.isIntersecting);
  }, [ carouselSectionNode ], { threshold: 0 });
  return (
    <LocalWinnersCarousel rootNode={carouselSectionNode}>
      {agencies.map(agency => (
        <CarouselItem key={agency.id}>
          <AgencySmartCard
            {...agency}
            isRegistered
            enablePhoneShowing={isMobile}
            sectionInView={sectionInView}
            rootNode={carouselSectionNode}
            withPropertyInfo
            variantToImagePath={variantToImagePath}
          />
        </CarouselItem>
      ))}
    </LocalWinnersCarousel>
  );
};
